import styled from '@emotion/styled'

export const TimelineStatusItemsListWrapper = styled.ul``

export const TimelineStatusItemsListItem = styled.li``
